<template>
  <div class="printingPage records">
    <div class="top">
      <BreadCrumb />
    </div>
    <div class="content">
      <div class="content-box">
        <div class="box">
          <div class="overview">
            <h3>数据概览</h3>
            <div class="overiviewRight">
              <datePicker @getMonth="getMonth"></datePicker>
              <div class="exportButton" @click="exportDetailsFn">
                <img src="@/assets/img/record/export.png" alt="导出" />
                <span>导出明细</span>
              </div>
            </div>
          </div>
          <div v-show="empty === 'notEmpty'" v-loading="$store.getters.loading">
            <div class="dataOverview">
              <ul>
                <li
                  :class="index === curindex ? 'active item' : 'item'"
                  v-for="(item, index) in outlineData"
                  :key="index"
                  @click="changeType(index)"
                >
                  <div class="itemBox">
                    <span class="tip">{{ index | outlineData }}</span>
                    <!-- <span class="itemIdentification">NUMBER</span> -->
                  </div>
                  <div class="itemNumber">{{ item }}</div>
                </li>
              </ul>
            </div>
            <echarts
              v-if="trend"
              :trend="trend"
              :trendTitle="trendTitle"
            ></echarts>
          </div>
          <!-- 空 -->
          <div class="emptyContent" v-show="empty === 'really'">
            <div class="box">
              <div>
                <img src="@/assets/img/record/empty.png" alt="" />
                <p>暂无数据</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { REQUEST_URL, APP_KEY } from "const";
import BreadCrumb from "cpnts/web/BreadCrumb.vue";
import echarts from "cpnts/web/echartsSmoothedLine/echarts";
import datePicker from "common/components/web/datePicker/datePicker";
import { outline, exportDetailed, statisticsDetailMonth } from "api/api";
import { signIn } from "utils/utils.js";
import { mapState } from "vuex";
export default {
  name: "printRecords",
  components: {
    echarts,
    datePicker,
    BreadCrumb
  },
  data() {
    return {
      empty: null, //打印记录是否为空
      month: null, //当前月份
      //概要数据
      outlineData: {
        printNum: null,
        printPaperNum: null
      },
      curindex: "printNum", //默认选中
      company: null, //单位
      trend: null, //趋势图数据
      trendTitle: null //当前趋势图标题
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "accessToken"])
  },
  methods: {
    init() {
      this.initData(this.month);
    },
    //概览切换
    changeType: function(index) {
      this.curindex = index;
      switch (index) {
        case "printPaperNum":
          this.company = "页";
          this.trendTitle = "：打印张数";
          this.toggleTrendData();
          break;
        case "printNum":
          this.company = "次";
          this.trendTitle = "：打印次数";
          this.toggleTrendData();
          break;
        default:
          break;
      }
    },
    // 获取数据
    initData(month) {
      outline({ months: month })
        .then(res => {
          const { data } = res;
          this.empty = "notEmpty"; //不为空
          delete data.months;
          delete data.printUserNum;
          this.outlineData = data;
        })
        .catch(() => {
          this.empty = "really"; //为空
        });
      statisticsDetailMonth({ months: month }).then(res => {
        this.totalTrend = res.data;
        this.toggleTrendData(res.data);
      });
    },
    // 切换数据
    toggleTrendData(data) {
      if (!data && !this.totalTrend) return;
      this.trend = (data || this.totalTrend).map(item => {
        const { printDate, printNum, printPaperNum } = item;
        if (this.curindex === "printNum") {
          return {
            date: printDate,
            count: printNum
          };
        }
        return {
          date: printDate,
          count: printPaperNum
        };
      });
    },
    //导出
    exportDetailsFn() {
      exportDetailed({ months: this.month })
        .then(res => {
          let src = `${REQUEST_URL}/printStatistics/downloadStatisticsDetailMonth?appKey=${APP_KEY}&months=${this.month}`;
          if (this.accessToken) src += `&accessToken=${this.accessToken}`;
          window.location.href = src;
        })
        .catch();
    },
    //打印纸张趋势图
    pageTrendFn(month) {
      this.trend = null;
      pageTrend({ months: month })
        .then(res => {
          const { data } = res;
          this.trend = data;
        })
        .catch();
    },
    //打印次数趋势图
    frequencyTrendFn(month) {
      this.trend = null;
      frequencyTrend({ months: month }).then(res => {
        const { data } = res;
        this.trend = data;
      });
    },
    //打印机次数趋势图
    usercountTrendFn(month) {
      this.trend = null;
      usercountTrend({ months: month }).then(res => {
        const { data } = res;
        this.trend = data;
      });
    },
    //获取当前月份
    getMonth(month) {
      this.month = month + "-01";
      this.initData(this.month);
    }
  },
  mounted() {
    if (!this.userInfo) return signIn();
    this.company = "次";
    this.trendTitle = "：打印次数";
    this.init();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .overiviewRight .el-input__inner {
  cursor: pointer;
}
.records {
  width: 100%;
  .content {
    min-height: calc(100% - 120px);
    background-color: #ffffff;
    border-radius: 4px;
    .content-box {
      // height: 100%;
      min-height: calc(100vh - 180px);
      background-color: #ffffff;
    }
    .box {
      padding: 30px;
      height: 100%;
    }
  }
  .emptyContent {
    height: calc(100vh - 274px);
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        text-align: center;
      }
    }
    p {
      color: #424242;
      font-size: 16px;
      margin: 18px 0 0 0;
    }
  }
  .top {
    display: flex;
    align-items: center;
  }
}
.overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #212121;
  font-size: 18px;
  h3 {
    font-size: 18px;
  }
  .overiviewRight {
    display: flex;
    cursor: pointer;
    .exportButton {
      width: 95px;
      height: 32px;
      background-color: $theme-color;
      border-radius: 2px;
      color: #ffffff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0px 0 10px;
      cursor: pointer;
      &:hover {
        background: $theme-color-hover;
      }
      img {
        margin: 0 7px 0 0;
      }
    }
  }
}
.dataOverview {
  ul {
    display: flex;
    padding: 30px 0 40px 0;
  }
  li,
  li.item {
    flex-shrink: 0;
  }
  li {
    width: 30%;
    height: 163px;
    padding: 30px;
    box-sizing: border-box;
    margin: 0 20px 0 0;
    cursor: pointer;
  }
  li.item {
    width: 30%;
    height: 163px;
    background-color: #fafafa;
    border-radius: 8px;
  }
  li.item {
    .itemBox {
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      height: 52px;
      border-bottom: 1px solid #eeeeee;
      .tip {
        color: #666666;
        font-size: 14px;
        float: left;
      }
    }
    .itemNumber {
      display: flex;
      font-size: 52px;
      color: #424242;
      line-height: 69px;
    }
    .itemIdentification {
      font-size: 20px;
      color: #eeeeee;
      font-weight: bold;
      float: right;
    }
  }
}
.dataOverview li.active {
  background-image: linear-gradient(-24deg, #5798ff 0%, #2d6eff 100%),
    linear-gradient($theme-color, $theme-color);
  background-blend-mode: normal, normal;
  box-shadow: 0px 4px 18px 0px rgba(46, 155, 247, 0.4);
  border-radius: 8px;
  .itemBox .tip {
    color: #ffffff;
  }
  .itemNumber {
    color: #ffffff;
  }
}
.list {
  display: flex;
}
.statistics {
  width: 500px;
  margin: 0 50px 0 0;
  &:last-child {
    margin: 0;
  }
  .title {
    background-color: #fafafa;
    border-radius: 2px;
    color: #424242;
    font-size: 16px;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    img {
      margin: 0 6px 0 0;
    }
  }
  li {
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .itemLeft {
      display: flex;
      align-items: center;
      img,
      .rank {
        width: 18px;
        margin: 0 10px 0 0;
      }
      .rank {
        font-size: 18px;
        color: #bbbbbb;
        font-weight: bold;
      }
      .name {
        max-width: 270px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .itemRight {
      min-width: 40px;
      span {
        color: #424242;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .num {
      color: #bbbbbb;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.footer {
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  color: #888888;
  font-size: 12px;
}
</style>
